export default "__VITE_ASSET__M3T$OBnz__"